import { configureStore } from '@reduxjs/toolkit';
import { ThunkAction, withExtraArgument } from 'redux-thunk';
import { AnyAction } from 'redux';

import helpCenter from './slices/helpCenter';
import community from './slices/community';
import user from './slices/user';
import tickets from './slices/tickets';
import modals from './slices/modals';
import appState from './slices/appState';
import notifications from './slices/notifications';
import api from '../api';
import search from './slices/search';

export const store = configureStore({
  reducer: {
    helpCenter,
    community,
    user,
    tickets,
    modals,
    search,
    appState,
    notifications,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(withExtraArgument(api)),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type TThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, typeof api, AnyAction>;
